var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPineapple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02466 14.4521C6.10763 13.5356 6.3967 12.6785 6.84516 11.9277L9.84135 13.0379L6.02466 14.4521Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.9104V20C6 20.2346 6.0404 20.4598 6.11464 20.669L10.1887 18.8158L6 16.9104Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.6397L7.18842 21.8285C7.43645 21.9387 7.71107 22 8.00001 22H16C16.2889 22 16.5636 21.9387 16.8116 21.8285L12 19.6397Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8854 20.669L13.8113 18.8158L18 16.9104V20C18 20.2346 17.9596 20.4598 17.8854 20.669Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9918L6.96722 15.7025L12 13.8377L17.0328 15.7025L12 17.9918Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1586 13.0379L17.9753 14.4521C17.8923 13.5356 17.6033 12.6785 17.1548 11.9277L14.1586 13.0379Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1753 10.691C15.0952 9.64426 13.6228 8.99998 12 8.99998C10.3772 8.99998 8.90482 9.64426 7.82477 10.691L12 12.2381L16.1753 10.691Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3427 3.88126C8.0297 1.74061 4.359 1.63089 5.09616 2.5382C5.31526 2.80786 5.54911 3.06944 5.78299 3.33105C6.25072 3.85423 6.71856 4.37754 7.06869 4.96589C7.11521 5.04406 7.16041 5.12247 7.20436 5.2009C5.75763 4.82201 4.66182 5.00353 5.09615 5.5381C5.31525 5.80777 5.5491 6.06935 5.78298 6.33095C6.25071 6.85414 6.71855 7.37744 7.06868 7.9658C7.26207 8.29077 7.4328 8.62009 7.58471 8.93694C8.82299 8.03403 10.3501 7.49999 12 7.49999C13.6498 7.49999 15.177 8.03403 16.4153 8.93693C16.5672 8.62008 16.7379 8.29077 16.9313 7.9658C17.2814 7.37744 17.7493 6.85411 18.217 6.33092C18.4509 6.06933 18.6847 5.80776 18.9038 5.5381C19.3382 5.00354 18.2424 4.82201 16.7957 5.20089C16.8396 5.12246 16.8848 5.04405 16.9313 4.96589C17.2815 4.37754 17.7493 3.85424 18.217 3.33106C18.4509 3.06945 18.6848 2.80786 18.9039 2.5382C19.641 1.63089 15.9703 1.74061 13.6572 3.88128C13.4087 3.33103 13.0583 2.81556 12.6061 2.36334C12.2713 2.02861 11.7286 2.02861 11.3939 2.36334C10.9417 2.81555 10.5913 3.33102 10.3427 3.88126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineapple);
export default __webpack_public_path__ + "static/media/pineapple.8e92b970b49dd319a89ca23b0bbe35c1.svg";
export { ForwardRef as ReactComponent };